import { Nullable } from '@/model/common';
import { InferType, object } from 'yup';
import { safeString } from './common';

export const watchListSchema = () => object({ name: safeString().required('Watchlist name cannot be empty!') });

export type WatchListFormValues = InferType<ReturnType<typeof watchListSchema>>;
export type WatchListFormInput = Nullable<WatchListFormValues>;
